import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as randomize from "randomatic";

import {
  AcquisitionTypeDto,
  CurrencyDto,
  LandTitleDto,
  MeasureDto,
  SubSubGroupDto,
  SubGroupDto,
  GroupDto,
  AccountableFunctionDto,
  CategoryDto, LandUseStatusDto, DivestmentStatusDto, BankingStatusDto, TerrainDto, PurposeDto, RightHeldDto, MeasuringFactorDto, LandParcelDto, AppConfigurationDto, GeoDatumDto, CommunitiesDto, DivisionTblDto, LgaDto, StateDto, CabinetShelfRefDto, RackTrayRefDto, FiscalFileLocationDto, StorageLocationDto, DocumentTypeDto, DocumentTypeCodeDto, SecurityClassificationDto, LandTitleRegisterDto, TitleDto, AddressBookDto, BankDto, OwnershipTypeDto, LessorInfoDto, LessorAreaMakerDto, IndividualAcreagesDto, LessorRepresentativeDto, LessorRepTypeDto, LandTitleNameDto, AssetLocationDto, CofOStatusDto, IncidentQuantumOfImpactDto, LessorStakeholderDto
} from "@cradua/data";
import { AddressBookComponent } from './address-book/address-book.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PreviousLandNameModalComponent } from './previous-land-name-modal/previous-land-name-modal.component';

@Component({
  selector: "cradua-create-acquisition",
  templateUrl: "./create-acquisition.component.html",
  styleUrls: ["./create-acquisition.component.scss"],

  //  // attach the fade in animation to the host (root) element of this component
  // host: { '[@fadeInAnimation]': '' },
})
export class CreateAcquisitionComponent implements OnChanges {
  @Input() loggedInUser: any;
  @Input() activities: any[];
  @Input() subSubGroups: SubSubGroupDto[];
  @Input() subGroups: SubGroupDto[];
  @Input() groups: GroupDto[];
  @Input() measures: MeasureDto[];
  @Input() currencies: CurrencyDto[];
  @Input() acquisitionTypes: AcquisitionTypeDto[];
  @Input() accountableFunctions: AccountableFunctionDto[];
  @Input() categories: CategoryDto[];
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Input() landUseStatus: LandUseStatusDto[];
  @Input() divestment: DivestmentStatusDto[];
  @Input() rightHeld: RightHeldDto[];
  @Input() purposes: PurposeDto[];
  @Input() terrains: TerrainDto[];
  @Input() uoms = [];
  @Input() quantums: IncidentQuantumOfImpactDto[];
  @Input() bankingStatus: BankingStatusDto[];
  @Input() measuringFactors: MeasuringFactorDto[];
  @Input() landParcels: LandParcelDto[];
  @Input() landTitles: LandTitleDto[];
  @Input() appConfigs: AppConfigurationDto[];
  @Input() geoDatums: GeoDatumDto[];
  @Input() divisions: DivisionTblDto[];
  @Input() communities: CommunitiesDto[];
  @Input() cabinetShelfRefs: CabinetShelfRefDto[];
  @Input() rackTrayRefs: RackTrayRefDto[];
  @Input() fileLocations: FiscalFileLocationDto[];
  @Input() lgas: LgaDto[];
  @Input() states: StateDto[];
  @Input() documentTypeCodes: DocumentTypeCodeDto[];
  @Input() documentTypes: DocumentTypeDto[];
  @Input() securityClassifications: SecurityClassificationDto[];
  @Input() fetchDocuments: LandTitleRegisterDto[];
  @Input() lessorInfos: LessorInfoDto[];
  @Input() lessorAreaMakers: LessorAreaMakerDto[];
  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Input() lessorStakeholders: LessorStakeholderDto[];
  @Input() individualAcreages: IndividualAcreagesDto[];
  @Input() assetLocations: AssetLocationDto[];
  @Input() titles: TitleDto[];
  @Input() banks: BankDto[];
  @Input() ownershipTypes: OwnershipTypeDto[];
  @Input() addressBooks: AddressBookDto[];
  @Input() cofOStatus: CofOStatusDto[];
  @Input() completed: boolean;
  @Input() progress: number;
  @Input() error: string;
  @Input() isInProgress: boolean;
  @Input() isReady: boolean;
  @Input() hasFailed: boolean;
  @Input() isLoadingAddressBook: boolean;
  @Input() isLoadingDocument: boolean;
  @Input() isLoadingLessorAreaMaker: boolean;
  @Input() isLoadingLessorRepresentative: boolean;
  @Input() isLoadingLessorStakeholder: boolean;
  @Input() isLoadingIndividualAcreages: boolean;
  @Input() isLoadingAssetLocation: boolean;
  @Input() isLoadingLessorInfo: boolean;

  PaymentType = 'LandTitle'

  @Output() emitLandTitle = new EventEmitter<LandTitleDto>();
  @Output() emitLandParcel = new EventEmitter<LandParcelDto>();
  @Output() emitUpload = new EventEmitter<any>();
  @Output() emitSaveManyDoc = new EventEmitter<any>();
  @Output() emitReset = new EventEmitter<any>();
  @Output() emitCancel = new EventEmitter<any>();
  @Output() emitAddressBook = new EventEmitter<any>();
  @Output() emitSaveAddressBook = new EventEmitter<any>();
  @Output() emitSaveAddressBookLessor = new EventEmitter<any>();
  @Output() emitFindAddressBookById = new EventEmitter<any>();
  @Output() emitUpdateAddressLessorInfo = new EventEmitter<any>();
  @Output() emitLessorAreaMaker = new EventEmitter<any>();
  @Output() emitLessorRepresentative = new EventEmitter<any>();
  @Output() emitLessorStakeholder = new EventEmitter<any>();
  @Output() emitIndividualAcreages = new EventEmitter<any>();
  @Output() emitAssetLocation = new EventEmitter<any>();
  @Output() emitClearAddressBook = new EventEmitter<any>();
  @Output() emitLessorAreaMakerDelete = new EventEmitter<any>();
  @Output() emitLessorRepresentativeDelete = new EventEmitter<any>();
  @Output() emitLessorStakeholderDelete = new EventEmitter<any>();
  @Output() emitIndividualAcreagesDelete = new EventEmitter<any>();
  @Output() emitAssetLocationDelete = new EventEmitter<any>();
  @Output() emitLessorInfoDelete = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();
  @ViewChild(AddressBookComponent) addressBookComponentChild: AddressBookComponent;

  filterSubGroup: SubGroupDto[];
  filterSubSubGroup: SubSubGroupDto[];
  filterCommunities: CommunitiesDto[];
  filterLgas: LgaDto[];
  selectedMeasureFactor: MeasuringFactorDto;
  selectedLandTitle: LandTitleDto;
  selectedTabIndex = 0;
  acquisitionForm: FormGroup;
  acquisitionBasicDataForm: FormGroup;

  showTab = false;
  isExpanded = true;
  formErr: boolean;
  loggedInUserDetail: any;
  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog
    ) {}

  ngOnChanges(change: SimpleChanges): void {
    this.loggedInUserDetail = this.loggedInUser != null ? this.loggedInUser.user : null;
    // console.log('loggedInUser ', this.landTitles);
    this.createAcquisitionForm();
    if(this.landTitles && this.landTitles.length) {
      this.selectedLandTitle = this.landTitles[0];
      this.onViewOrEdit(this.landTitles[0]);
      this.showTab = true;
    } else {
      this.showTab = false;
      this.selectedLandTitle = null;
    }
  }

  tabChanged(tabChangeEvent): void {
    // console.log('tabChangeEvent => ', tabChangeEvent);
    // // this.selectedTabIndex = 7;
    this.isExpanded = false;
  }


  onEmitCreateAddressBook(value) {
    this.selectedTabIndex = value.selectedIndex;
    this.isExpanded = false;
    this.addressBookComponentChild.task = 'create';

  }


  onLandName() {

    const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "80%";
    dialogConfig.width = "60%";
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";

    dialogConfig.data = {
      LandTitleName: this.selectedLandTitle.landTitleNames,
    }

    const dialogRef = this.dialog.open(
      PreviousLandNameModalComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result: LandTitleNameDto[]) => {
      // console.log('result got ', result);
      if(result !== undefined) {
        const newLandTitle = Object.assign({}, this.selectedLandTitle);
        newLandTitle.landTitleNames = result;
        this.emitLandTitle.emit(newLandTitle);
      }

    });
  }

  onViewOrEdit(selectedValue: LandTitleDto) {
    if(selectedValue) {
      this.acquisitionForm.patchValue({
      LandName: selectedValue.LandName,
      LandRemarks: selectedValue.LandRemarks,
      LandCode: selectedValue.LandCode,
      LandCodeRemarks: selectedValue.LandCodeRemarks,
      LandEndUseRemarks: selectedValue.LandEndUseRemarks,
      AccountableFunctionId: selectedValue.AccountableFunctionId,
      CategoryId: selectedValue.CategoryId,
      GroupId: selectedValue.GroupId,
      SubGroupId: selectedValue.SubGroupId,
      SubSubGroupId: selectedValue.SubSubGroupId,
      AcquisitionDate: selectedValue.AcquisitionDate != null ? this.formatDate(selectedValue.AcquisitionDate): null,
      ExpirationDate: selectedValue.ExpirationDate != null ? this.formatDate(selectedValue.ExpirationDate) : null,
      Duration: selectedValue.Duration,
      TotalCost: selectedValue.TotalCost,
      CurrencyId: selectedValue.CurrencyId,
      TotalArea: selectedValue.TotalArea,
      RecTotalArea: selectedValue.RecTotalArea,
      MeasureId: selectedValue.MeasureId,
      AcquisitionTypeId: selectedValue.AcquisitionTypeId,
      DivestmentStatusId: selectedValue.DivestmentStatusId,
      RightHeldId: selectedValue.RightHeldId,
      PurposeId: selectedValue.PurposeId,
      TerrainId: selectedValue.TerrainId,
      BankingStatus_BankingStatusId: selectedValue.BankingStatus_BankingStatusId,
      LandUseStatusId: selectedValue.LandUseStatusId,
      SurveyDrawingNoMap: selectedValue.SurveyDrawingNoMap,
      UrlOfDrawing: selectedValue.UrlOfDrawing,
      DatumId: selectedValue.DatumId,
      PobLatitudeDegree: selectedValue.PobLatitudeDegree,
      PobLatitudeMin: selectedValue.PobLatitudeMin,
      AssetLocationAddress: selectedValue.AssetLocationAddress,
      PobLatitudeSec: selectedValue.PobLatitudeSec,
      PobLongitudeDegree: selectedValue.PobLongitudeDegree,
      PobLongitudeMin: selectedValue.PobLongitudeMin,
      PobLongitudeSec: selectedValue.PobLongitudeSec,
      Easting: selectedValue.Easting,
      Northing: selectedValue.Northing,
      StateId: selectedValue.StateId,
      LgaId: selectedValue.LgaId,
      DivisionId: selectedValue.DivisionId,
      CommunityId: selectedValue.CommunityId,
      SurveyDate: selectedValue.SurveyDate != null ? this.formatDate(selectedValue.SurveyDate) : null,
      LHectares: selectedValue.LHectares,
      LAcres: selectedValue.LAcres,
      LSqKilometers: selectedValue.LSqKilometers,
      LSqMeters: selectedValue.LSqMeters,
      LSqFeet: selectedValue.LSqFeet,
      LRoods: selectedValue.LRoods,
      LPerche: selectedValue.LPerche,
      LPlot: selectedValue.LPlot,
      CofONumber: selectedValue.CofONumber,
      CofOStatusId: selectedValue.CofOStatusId,
      CofODate: selectedValue.CofODate != null ? this.formatDate(selectedValue.CofODate) : null,
      COfOExpirationDate: selectedValue.COfOExpirationDate != null ? this.formatDate(selectedValue.COfOExpirationDate) : null,
      CofORemarks: selectedValue.CofORemarks,
      CofORevocationDate: selectedValue.CofORevocationDate != null ? this.formatDate(selectedValue.CofORevocationDate) : null,
      CofOReasonsForRevocation: selectedValue.CofOReasonsForRevocation,
      id: selectedValue.id
      });

        this.acquisitionForm.controls['LandCode'].disable();
        // this.acquisitionForm.patchValue({LandCode: selectedValue.LandCode});
      this.onFilterSubGroup(selectedValue.GroupId);
      this.onFilterSubSubGroup(selectedValue.SubGroupId);
      this.onFilterLga(selectedValue.StateId);
      this.onFilterCommunity(selectedValue.LgaId);
    this.selectedMeasureFactor = this.onSelectedMeasure(selectedValue.MeasureId);
      if(selectedValue.AcquisitionDate && selectedValue.ExpirationDate && selectedValue.Duration === null) {
     const duration = this.days_between(selectedValue.AcquisitionDate, selectedValue.ExpirationDate).toFixed(0);
      this.acquisitionForm.controls['Duration'].patchValue(duration);
      }
    }
  }

  onAcquisitionDate(value) {

    if(value && this.acquisitionForm.value.ExpirationDate) {
      const duration = this.days_between(this.acquisitionForm.value.AcquisitionDate, this.acquisitionForm.value.ExpirationDate).toFixed(0);
      this.acquisitionForm.controls['Duration'].patchValue(duration);
    }

  }
  onExpirationDate(value) {
    if(value && this.acquisitionForm.value.AcquisitionDate) {
      const duration = this.days_between(this.acquisitionForm.value.AcquisitionDate, this.acquisitionForm.value.ExpirationDate).toFixed(0);
      this.acquisitionForm.controls['Duration'].patchValue(duration);
    }
  }

  onDuration(value) {
    if(value && this.acquisitionForm.value.AcquisitionDate === null) {
      const formatDateNow = this.formatYearDate(0);
      this.acquisitionForm.controls['AcquisitionDate'].patchValue(formatDateNow);
    } else if(value && this.acquisitionForm.value.ExpirationDate === null) {
      const formatDate = this.formatYearDate(value);
      this.acquisitionForm.controls['ExpirationDate'].patchValue(formatDate);
    }
    if(value) {
      const formatDate = this.formatYearDate(value);
      this.acquisitionForm.controls['ExpirationDate'].patchValue(formatDate);
    } else {
      const formatDate = this.formatYearDate(value);
      this.acquisitionForm.controls['ExpirationDate'].patchValue(formatDate);
    }
  }

  createAcquisitionForm() {
    this.acquisitionForm = this.fb.group({
      LandName: ['', Validators.required],
      LandRemarks: [''],
      LandCode: ['', Validators.required],
      LandCodeRemarks: [''],
      LandEndUseRemarks: [''],
      AccountableFunctionId: [''],
      CategoryId: [''],
      GroupId: [''],
      SubGroupId: [''],
      SubSubGroupId: [''],
      AcquisitionDate: null,
      ExpirationDate: null,
      Duration: null,
      TotalCost: null,
      CurrencyId: [''],
      TotalArea: null,
      RecTotalArea: [0],
      MeasureId: null,
      AcquisitionTypeId: [''],
      DivestmentStatusId: [''],
      RightHeldId: [''],
      PurposeId: [''],
      TerrainId: [''],
      BankingStatus_BankingStatusId: [''],
      LandUseStatusId: [''],
      SurveyDrawingNoMap: [''],
      UrlOfDrawing: [''],
      DatumId: [''],
      PobLatitudeDegree: null,
      PobLatitudeMin: null,
      AssetLocationAddress: null,
      PobLatitudeSec: null,
      PobLongitudeDegree: null,
      PobLongitudeMin: null,
      PobLongitudeSec: null,
      DocumentTitle: null,
      DocumentTypeCodeId: null,
      DocumentTypeId: null,
      Url: null,
      Easting: null,
      Northing: null,
      StateId: null,
      LgaId: null,
      DivisionId: null,
      CommunityId: null,
      SurveyDate: null,
      LHectares: null,
      LAcres: null,
      LSqKilometers: null,
      LSqMeters: null,
      LSqFeet: null,
      LRoods: null,
      LPerche: null,
      LPlot: null,
      CofONumber: null,
      CofOStatusId: null,
      CofODate: null,
      COfOExpirationDate: null,
      CofORemarks: null,
      CofORevocationDate: null,
      CofOReasonsForRevocation: null,
      id: null
    });

    // this.acquisitionBasicDataForm = this.fb.group({
    //   CurrencyId: ['']
    // })
  }

  protected filterById = <T>(id: string, lookupId: string) =>
    (fieldName: T) => fieldName[lookupId] === id;

  onFilterSubGroup(id: string) {
    this.filterSubGroup = this.subGroups.filter(
      this.filterById<SubGroupDto>(id, "GroupId"),
    );
  }

  onFilterSubSubGroup(id: string) {
    this.filterSubSubGroup = this.subSubGroups.filter(
      this.filterById<SubSubGroupDto>(id, "SubGroupId"),
    );
  }

  onFilterLga(id: string) {
    this.filterLgas = this.lgas.filter(
      this.filterById<LgaDto>(id, "StateId"),
    );
  }

  onFilterCommunity(id: string) {
    this.filterCommunities = this.communities.filter(
      this.filterById<CommunitiesDto>(id, "LgaId"),
    );
  }

  public errorHandling = (control: string, error: string, type?: string) => {
    const formControl = this.acquisitionForm.controls[control];
    return formControl.hasError(error);
  };

  onSubmit(formValue: LandTitleDto) {

    if(this.acquisitionForm.invalid) {
      return;
    }
    this.showTab = true;
    this.emitLandTitle.emit(formValue);
  }

  onChangeLandCodeGenerator(event: string) {
    if(event === 'Automatic') {
      const generatedCode = `LND${randomize("0", 6)}`
      this.acquisitionForm.patchValue({LandCode: generatedCode});
      this.acquisitionForm.controls['LandCode'].disable()
    } else {
      if(this.acquisitionForm.controls['LandCode'].status === 'DISABLED') {
        this.acquisitionForm.controls['LandCode'].enable();
        this.acquisitionForm.patchValue({LandCode: ''});
      }
    }
  }

  protected multiplyTwoNumbers = (totalArea: number, measuringFactor: number): number  =>
  totalArea != null && measuringFactor != null? (totalArea * measuringFactor) : 0;

  onSelectedMeasure(id: string) {
    return this.measuringFactors.find(
      this.filterById<MeasuringFactorDto>(id, "MeasureId"),
    );
    }

  calcMeasure() {
    const selectedValue: LandTitleDto = this.acquisitionForm.value;
    this.acquisitionForm.patchValue({
      LHectares:  this.multiplyTwoNumbers(selectedValue.RecTotalArea, this.selectedMeasureFactor.Hectares).toFixed(6),
      LAcres:  this.multiplyTwoNumbers(selectedValue.RecTotalArea, this.selectedMeasureFactor.Acre).toFixed(6),
      LSqKilometers:  this.multiplyTwoNumbers(selectedValue.RecTotalArea, this.selectedMeasureFactor.SqKM).toFixed(6),
      LSqMeters:  this.multiplyTwoNumbers(selectedValue.RecTotalArea, this.selectedMeasureFactor.SqM).toFixed(6),
      LSqFeet:  this.multiplyTwoNumbers(selectedValue.RecTotalArea, this.selectedMeasureFactor.SqF).toFixed(6),
      LRoods:  this.multiplyTwoNumbers(selectedValue.RecTotalArea,this.selectedMeasureFactor.Rood).toFixed(6),
      LPerche:  this.multiplyTwoNumbers(selectedValue.RecTotalArea, this.selectedMeasureFactor.Perche).toFixed(6),
      LPlot:  this.multiplyTwoNumbers(selectedValue.RecTotalArea, this.selectedMeasureFactor.Plot).toFixed(6),
    });
  }

  onInput(value) {
    if(this.selectedMeasureFactor != null) {
      this.calcMeasure();
    }
  }

  onMeasure(value: string) {
     this.selectedMeasureFactor = this.onSelectedMeasure(value);
      this.calcMeasure();
  }

  onEmitLandParcel(value: LandParcelDto[]) {
    const newLandTitle = Object.assign({}, this.selectedLandTitle);
     newLandTitle.landParcels = value;
     this.emitLandTitle.emit(newLandTitle);
  }

  onSaveStorageLocation(value: StorageLocationDto[]) {
    const storageLocation = Object.assign({}, this.selectedLandTitle);
    storageLocation.storageLocations = value;
     this.emitLandTitle.emit(storageLocation);
  }

  // onEmitAssetLocation(value: AssetLocationDto[]) {
  //   const assetLocation = Object.assign({}, this.selectedLandTitle);
  //   assetLocation.assetLocations = value;
  //    this.emitLandTitle.emit(assetLocation);
  // }

  onUploadFile(value) {
    this.emitUpload.emit(value);
  }

  onSaveManyDoc(value: LandTitleRegisterDto[]) {
    this.emitSaveManyDoc.emit(value);
  }

  onCancelUpload() {
    this.emitCancel.emit('');
  }

  onResetUpload() {
    this.emitReset.emit('');
  }

  onSearchAddressBook(query) {
    this.emitAddressBook.emit(query);
  }

  onSaveAddressBook(value: AddressBookDto) {
    this.emitSaveAddressBook.emit(value);
    const addressBook = Object.assign({}, value);
    if(addressBook.id != null) {
      addressBook['LandTitleId'] = this.selectedLandTitle.id;
      addressBook['BankId'] = this.getBankName(addressBook.BankId);
      this.emitUpdateAddressLessorInfo.emit(addressBook)
    }
  }

  getBankName(id: string) {
   const found = this.banks.find(bank => bank.id === id);
   return found ? found.BankName : null;
  }
  onEmitAddressBookLessor(value) {
    const lessorInfo = [];
    value['LandTitleId'] = this.selectedLandTitle.id;
    value['SerialNo'] = this.selectedLandTitle.id;
    lessorInfo.push(value);
    this.emitSaveAddressBookLessor.emit(lessorInfo);
  }

  // onFindAddressBookById(id: string) {
  //   this.emitFindAddressBookById.emit(id);
  // }

  onEmitLessorAreaMaker(value: LessorAreaMakerDto[]) {
    this.emitLessorAreaMaker.emit(value);
  }
  onEmitLessorRepresentative(value: LessorRepresentativeDto[]) {
    this.emitLessorRepresentative.emit(value);
  }

  onEmitLessorStakeholder(value: LessorStakeholderDto[]) {
    this.emitLessorStakeholder.emit(value);
  }
  onEmitIndividualAcreages(value: IndividualAcreagesDto[]) {
    this.emitIndividualAcreages.emit(value);
  }

 onEmitAssetLocation(value: AssetLocationDto[]) {
    this.emitAssetLocation.emit(value);
  }

  onEmitClearAddressBook(value) {
    this.emitClearAddressBook.emit(value);
  }

  onEmitLessorAreaMakerDelete(value) {
    this.emitLessorAreaMakerDelete.emit(value);
  }
  onEmitLessorRepresentativeDelete(value) {
    this.emitLessorRepresentativeDelete.emit(value);
  }
  onEmitLessorStakeholderDelete(value) {
    this.emitLessorStakeholderDelete.emit(value);
  }
  onEmitIndividualAcreagesDelete(value) {
    this.emitIndividualAcreagesDelete.emit(value);
  }
  onEmitAssetLocationDelete(value) {
    this.emitAssetLocationDelete.emit(value);
  }
  onEmitLessorInfoDelete(value) {
    this.emitLessorInfoDelete.emit(value);
  }

  formatYearDate(numb: number) {
    // tslint:disable-next-line: one-variable-per-declaration
    let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = (+d.getFullYear() + +numb);
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  formatDate(date) {
    // tslint:disable-next-line: one-variable-per-declaration
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  days_between(date1, date2) {
    // The number of milliseconds in all UTC days (no DST)
    const oneDay = (1000 * 60 * 60 * 24) * 365;
    const StartDate = new Date(date1);
    const EndDate = new Date(date2);
    // A day in UTC always lasts 24 hours (unlike in other time formats)
    const start = Date.UTC(
      EndDate.getFullYear(),
      EndDate.getMonth(),
      EndDate.getDate()
    );
    const end = Date.UTC(
      StartDate.getFullYear(),
      StartDate.getMonth(),
      StartDate.getDate()
    );

    // so it's safe to divide by 24 hours
    return (start - end) / oneDay;
  }
}
